/* eslint-disable */
const Line = {
    initOptions() {
        return {
            renderer: 'canvas'
        }
    },
    /**
     * {
     * title: 'xxxx',
     * yShow: true,
     * xData: [],
     * yData: []
     * }
     */
    getOptions(opt) {
        return {
            title: {
                text: opt.title,
                top: `6%`,
                left: `45%`,
                textStyle: {
                    fontSize: 14,
                    fontWeight: `normal`,
                }
            },
            color: (opt.color || ['#306BFF', '#16B678', '#FF502F', '#FCA84E', '#A947FF' ]),
            legend: {
                ...{
                    data: opt.legendData,
                    bottom: -5,
                    itemWidth: 16,
                    itemHeight: 16,
                    itemGap: 10,
                    icon: 'rect'
                },
                ...(opt.legend || {})
            },
            tooltip: {
                ...{
                    trigger: 'axis',
                    axisPointer: {
                        // 指示轴置于下方
                        z: 1,
                        lineStyle: {
                            color: '#DBDBDB',
                            width: 2,
                        }
                    },
                    padding: 10,
                    // 当图表外层的 dom 被设置为 'overflow: hidden'，或者移动端窄屏，导致 tooltip 超出外界被截断时，此配置比较有用。
                    confine: true,
                },
                ...(opt.tooltip || {})
            },
            xAxis: {
                ...{
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                        color: '#666666',
                        // interval: opt.custInterval ? (index, value) => {
                        //     if (index === 0 || index === (opt.xData.length -1)) {
                        //         return true
                        //     } else {
                        //         return index%opt.custInterval === 0
                        //     }
                        // } : 'auto'
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#DBDBDB',
                            width: 1,
                            // type: 'dashed',
                        },
                    },
                    data: opt.xData,
                    axisTick: {
                        "show": false
                    },
                },
                ...opt.xAxis
            },
            yAxis: [{
                type: 'value',
                name: opt.yName || '',
                nameTextStyle: {
                    color: '#333',
                    fontSize: 16,
                },
                nameGap: 20,
                axisLabel: {
                    ...{
                        color: '#666666',
                        show: !!(opt.yShow),
                    },
                    ...opt.yAxisLabel
                },
                axisLine: {
                    show: !!(opt.yShow),
                    lineStyle: {
                        color: ['#DBDBDB'],
                        width: 2,
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: ['#EEEEEE'],
                        type: 'dashed',
                    },
                    ...(opt.yAxisSplitLine || {})
                },
                axisTick: {
                    show: !!(opt.yShow),
                },
                max: opt.max,
                interval: opt.max ? opt.max / 5 : undefined
            },
                opt.needDoubleY && {
                    type: 'value',
                    name: opt.y2Name || '',
                    nameTextStyle: {
                        color: '#333',
                        fontSize: 16,
                    },
                    nameGap: 20,
                    axisLabel: {
                        color: '#666666',
                        show: !!(opt.y2Show),
                    },
                    axisLine: {
                        show: !!(opt.y2Show),
                        lineStyle: {
                            color: ['#DBDBDB'],
                            width: 2,
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#EEEEEE'],
                            type: 'dashed',
                        }
                    },
                    axisTick: {
                        show: !!(opt.y2Show),
                    },
                    max: opt.max2,
                    interval: opt.max2 ? opt.max2 / 5 : undefined,
                    ...(opt.yAxis || {})
                }
            ],
            grid: {
                ...{
                    left: '0',
                    // top: '20%',
                    right: '5%',
                    // right: '4%',
                    bottom: '10%',
                    borderColor: '#EEEEEE',
                    containLabel: true
                },
                ...(opt.grid || {})
            },
            series: this.getSeries(opt.yData, opt)
        }
    },
    /**
     *
     * @param data
     * @param color
     * @param smooth
     * @param needArea
     * @param showSymbol
     * @param symbolSize
     * @param ifSeriesZindex 是否需要强制系列排布
     * @returns {Array}
     */
    getSeries:(data, {color, smooth = true, needArea = true, showSymbol=false, symbolSize = 5, ifSeriesZindex=true}) => {
        const result = []
        const colors = color || ['#306BFF', '#16B678','#FF502F', '#FCA84E', '#A947FF' ]
        for (const [index, dd] of data.entries()) {
            result.push({
                data: dd.data,
                type: 'line',
                // smooth: true,
                name: dd.name,
                symbolSize: symbolSize,
                symbol: 'circle',
                smooth: smooth,
                itemStyle: {
                    borderWidth: 2,
                    borderColor: '#fff',
                    width: 2,
                },
                // emphasis: {
                //     symbolSize,
                // },
                showSymbol: showSymbol,
                areaStyle: needArea ? {
                    // color: colors[index]
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0, color: colors[index] // 0% 处的颜色
                        }, {
                            offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                    },
                    opacity: 0.1
                }: null,
                // 是否需要强制系列排布
                z: ifSeriesZindex ? data.length - index : undefined,
                yAxisIndex: dd.yAxisIndex ? (dd.yAxisIndex - 0) : 0
            })
        }
        return result
    },
}

export default Line
